import { render, staticRenderFns } from "./IngressFullPath.vue?vue&type=template&id=47cad268&"
import script from "./IngressFullPath.vue?vue&type=script&lang=js&"
export * from "./IngressFullPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports